import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  ProdutoDto,
  ProdutoFiltrarDto,
  ProdutoFiltrarSchema,
} from "./Produto.Dto";
import { useEffect, useState } from "react";
import { ProdutoFiltrar } from "src/services/Estoque.Service";
import {
  criarMenuItem,
  filtrarRotasPorRotaAtual,
  MapearErrosServidor,
} from "src/hook/Functions";
import { MenuItemDto } from "../../Menu/MenuItem.Dto";
import { useLocation } from "react-router-dom";
import { showToast } from "src/componentes";

const ProdutoCode = () => {
  const [data, setData] = useState<ProdutoDto[] | undefined>([]);
  const [loading, setLoading] = useState(false);
  const [menuItens, setMenuItens] = useState<MenuItemDto[]>([]);
  const location = useLocation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ProdutoFiltrarDto>({
    resolver: yupResolver(ProdutoFiltrarSchema),
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      const dadosIniciais: ProdutoFiltrarDto = { nome: "" };
      onSubmit(dadosIniciais, null);
      carregarRotas();
    };
    Load();
    return () => {
      controller.abort();
    };
  }, []);

  const carregarRotas = () => {
    const rotas = filtrarRotasPorRotaAtual(location.pathname);
    rotas.push(criarMenuItem("Novo Produto", "/estoque/produtos/cadastro"));
    setMenuItens(rotas);
  };

  const onSubmit = async (data: ProdutoFiltrarDto, e: any) => {
    setLoading(true);
    try {
      const response = await ProdutoFiltrar(data);
      if (response.data.success) {
        const data = response.data.data;
        setData(data);
        if (data.length === 0) {
          showToast({
            message: "Não encontrado",
            title: "Info",
            variant: "Info",
          });
        }
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {}
    setLoading(false);
  };

  return {
    data,
    loading,
    register,
    handleSubmit,
    onSubmit,
    errors,
    menuItens,
  };
};

export default ProdutoCode;
